// API 설정 파일
export const API_CONFIG = {
  // 백엔드 API 서버 설정
  BASE_URL: import.meta.env.VITE_API_BASE_URL ?? '',

  // 타임아웃 설정 (밀리초)
  TIMEOUT: 10000,

  // 기본 헤더
  DEFAULT_HEADERS: {
    'Content-Type': 'application/json',
  },

  // API 엔드포인트
  ENDPOINTS: {
    // 주문 관련
    ORDERS: {
      ADD: '/api/v1/orders/add',
      MODIFY: '/api/v1/orders/modify',
      CANCEL: '/api/v1/orders/cancel',
      LIST: '/api/v1/orders',
    },

    // 포트폴리오 관련
    PORTFOLIO: {
      LIST: '/api/v1/portfolios',
      ORDERS: '/api/v1/portfolios/orders',
      POSITIONS: '/api/v1/portfolios/positions',
    },
  },
} as const;

// 환경별 설정
export const getApiConfig = () => {
  const isDevelopment = import.meta.env.DEV;

  return {
    ...API_CONFIG,
    BASE_URL: isDevelopment
      ? (import.meta.env.VITE_API_BASE_URL || 'http://localhost:5153')
      : (import.meta.env.VITE_API_BASE_URL ?? ''),
  };
};
